import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import ApiTokenSettingsForm from './ApiTokenSettingsForm';
import i18n from 'i18n';

interface ApiTokenSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeTokenId: number;
}

const ApiTokenSettingsModal: React.FC<ApiTokenSettingsModalProps> = React.memo(({
    modalOpen,
    closeModal,
    activeTokenId,
}) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_token_details.text')}
        entityId={activeTokenId}
        entityIdPropName="tokenId"
        FormComponent={ApiTokenSettingsForm}
    />
));

export default ApiTokenSettingsModal; 